<template>
  <!-- Table -->
  <div class="row flex-fill d-flex justify-content-start">
    <div class="col-md-12 mt-2">
      <table class="table table-borderless table-border table-align">
        <thead>
          <tr>
            <th>Tipo de documento</th>
            <th>Fase</th>
            <th>Nome do documento</th>
            <th>Atualizado em</th>
            <th>Reconferido em</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!documents.length">
            <td colspan="6" class="text-muted">Nenhum documento disponível.</td>
          </tr>
          <tr v-for="document in documents" :key="document.id">
            <td>{{ document.tipo }}</td>
            <td>{{ phaseLabel(document.fase) }}</td>
            <td>{{ document.filename }}</td>
            <td>{{ document.updatedAt | datetime }}</td>
            <td>
              <template v-if="document.reconferencias">
                <template v-if="document.reconferidoEm">{{ document.reconferidoEm | datetime }}</template>
                <template v-else>Sim</template>
                <small class="text-muted d-block">{{ discardedCaptures(document.reconferencias) }}</small>
              </template>
              <template v-else>-</template>
            </td>
            <td>
              <button class="btn btn-outline" @click="download(document)">
                Baixar documento
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import { discardedCaptures, phaseLabel } from '@/models/ticketDocuments'

export default {
  computed: {
    currentAxios() {
      return this.axios.v3
    },
    documents() {
      return (this.getModels || []).filter(document => this.$canDownloadKind('cm-embarcador', document.tipo))
    },
  },
  created() {
    this.params.perPage = 1000
    this.addOrderBy('createdAt')
    this.find()
  },
  data: () => ({
    modelPathPrefix: 'maestro',
    nameModel: 'Ticket',
    showModal: false,
    ticketId: null,
  }),
  methods: {
    discardedCaptures,
    phaseLabel,
    buildPath() {
      return `cm-embarcador/multas/${this.ticket.id}/documents`
    },
    download(document) {
      this.openLoad()
      this.axios.v3.get(`/cm-embarcador/documentos/${document.id}/link?filename=${document.filename}`)
        .then(response => this.$parse.downloadByLink(response.data))
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    },
    find() {
      this.asyncTemplateSelect()
    }
  },
  mixins: [ModelMapper],
  name: 'Documents',
  props: {
    ticket: {
      required: true,
      type: Object,
    }
  }
}

</script>

<style scoped></style>
